import {create} from "zustand";
import { CNumber, DMSBoxMapping } from '../types';

export interface DriveCNumbersState {
    cNumbers: CNumber[];
    setCNumbers: (cNumbers:CNumber[]) => void;
    isFetched: boolean;
    setIsFetched: (isFetched:boolean) => void;
    dmsBoxMapping: DMSBoxMapping | undefined;
    setDmsBoxMapping: (dmsBoxMapping: DMSBoxMapping) => void;
  }
  
export const useDriveCNumbersStore = create<DriveCNumbersState>((set) => ({
   cNumbers: [],
   setCNumbers: (cNumbers) => set(() => ({ cNumbers })),
   isFetched: false,
   setIsFetched: (isFetched) => set(() => ({ isFetched })),
   dmsBoxMapping: undefined,
   setDmsBoxMapping: (dmsBoxMapping) => set(() => ({ dmsBoxMapping })),
 }));
